import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import { Redirect } from 'react-router-dom';
import { ToastContainer,toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import "../TrainingFeedback.css";

const FeedbackQuestion = () => {

  const { trainingId } = useParams();

  const [titles,setTitles] = useState([]);
const [answers,setAnswers] = useState({});
const [loading, setLoading] = useState(false);
  const history = useHistory();

useEffect(()=>{
 fetchQuestions();
},[]);

const fetchQuestions = async () => {

  const res = await axios.get(`${API_BASE_URL}/feedback-questions`,{
    headers:{
      Authorization:`Bearer ${localStorage.getItem("authToken")}`
    }
  });

  const data = res.data.data;

  const defaultAnswers = {};

  data.forEach(title => {
    title.questions.forEach(q => {

      defaultAnswers[q.ques_id] = {
        title_id: title.title_id,
        answer: q.answertype === 2 ? 1 : ""   // rating default = 1
      };

    });
  });

  setTitles(data);
  setAnswers(defaultAnswers);
};

const handleAnswer = (titleId, questionId, value) => {

 setAnswers(prev => ({
   ...prev,
   [questionId]: {
     title_id: titleId,
     answer: value
   }
 }));

};



const handleSubmit = async (e) => {

 e.preventDefault();

//  alert(JSON.stringify(answers, null, 2)); // check answers


 console.log("Payload:", {
  training_participate_id: trainingId,
  answers: answers
});

 setLoading(true);

 try{

   await axios.post(
     `${API_BASE_URL}/submit-feedback`,
     {
       training_participate_id: trainingId,
       answers: answers
     },
     {
       headers:{
         Authorization:`Bearer ${localStorage.getItem("authToken")}`
       }
     }
   );

   toast.success("Feedback submitted successfully");

   setTimeout(()=>{
     history.push("/TrainingParticipateList");
   },2000);

 }catch(err){
   toast.error("Submit failed");
   setLoading(false);
 }

};

   return (
     <>
       <ToastContainer />

<div className="container-fluid">

<div className="card">

<div className="card-header">
<h4>Pre Test Exam</h4>
</div>

<div className="card-body">

<form onSubmit={handleSubmit}>

{titles.map((title)=>(
<div key={title.id} className="card mb-4">

<div className="card-header">
<b>{title.question_title}</b>
</div>

<div className="card-body">

{title.questions.map((q,index)=>(
<div key={q.ques_id} className="row align-items-center mb-3">

<div className="col-md-7">
{index+1}. {q.questions}
</div>

<div className="col-md-5">

{/* YES / NO */}
{q.answertype === 1 && (
<>
<label className="mr-3">
<input
 type="checkbox"
 checked={answers[q.ques_id]?.answer === "yes"}
 onChange={() => handleAnswer(title.title_id, q.ques_id, "yes")}
/> Yes
</label>

<label>
<input
 type="checkbox"
 checked={answers[q.ques_id]?.answer === "no"}
 onChange={() => handleAnswer(title.title_id, q.ques_id, "no")}
/> No
</label>
</>
)}

{/* RATING 1-5 + NA */}
{q.answertype === 2 && (
<>
{[1,2,3,4,5].map(v=>(
<label key={v} className="mr-2">
<input
 type="checkbox"
checked={answers[q.ques_id]?.answer === v}
 onChange={() => handleAnswer(title.title_id, q.ques_id, v)}
/> {v}
</label>
))}

<label className="ml-2">
<input
 type="checkbox"
 checked={answers[q.ques_id]?.answer === "NA"}
 onChange={() => handleAnswer(title.title_id, q.ques_id, "NA")}
/> NA
</label>
</>
)}

{/* TEXT */}
{q.answertype === 3 && (
<textarea
 className="form-control"
 rows="3"
 onChange={(e)=>handleAnswer(title.title_id, q.ques_id, e.target.value)}
/>
)}

</div>

</div>
))}

</div>
</div>
))}

<div className="text-center">
<button className="btn btn-primary" disabled={loading}>
{loading ? "Submitting..." : "Submit"}
</button>
</div>

</form>

</div>

</div>

</div>

   </>
  );

}

export default FeedbackQuestion;